import type { IOrderPaymentConfirmation } from "@/data/model/Customer";

import { logError } from "@/shared/logging/errors";

import { Popup } from "@/components/dialog/Popup";

import PaymentReceivedPopoverComponent from "@/app/components/payment/PaymentReceivedPopover.vue";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class PaymentReceivedPopover extends VueContentPopover {
    public onStartOver?: { () };
    public onReceiptAndMore?: { () };
    public onFinish?: { () };

    constructor(options: {
        confirmation: IOrderPaymentConfirmation;
        isWaiterOrAdmin: boolean;
        showReceiptActionsForOperator: boolean;
        uniqueId: string | undefined;
    }) {
        super({ popoverClass: "payment-received-popover", flexHeight: true, condensed: true, uniqueId: options.uniqueId });

        try {
            const props = {
                confirmation: options.confirmation,
                isWaiterOrAdmin: options.isWaiterOrAdmin,
                showReceiptActionsForOperator: options.showReceiptActionsForOperator,
                hide: () => this.hide(),
                updateBodyHeight: () => this.updateBodyHeight(),
                onStartOver: () => {
                    if (this.onStartOver) {
                        this.onStartOver();
                    }
                },
                onReceiptAndMore: () => {
                    if (this.onReceiptAndMore) {
                        this.onReceiptAndMore();
                    }
                },
                onFinish: () => {
                    if (this.onFinish) {
                        this.onFinish();
                    }
                },
            };
            this.initComponent(PaymentReceivedPopoverComponent, props);
        } catch (ex) {
            logError(ex);
            Popup.show({ message: "Error showing done popover" });
            this.hide();
        }
    }
}
